exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-box[data-v-3cc457e8] {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: -40px;\n  margin-bottom: 20px;\n}", ""]);

// exports
